import { useState } from "react";
import { apiPost } from "../api/http";
import { useToast } from "../context/ToastContext";

export default function AuditFeedbackWidget({ auditId, url, onSubmitted }) {
  const { showSuccess, showError } = useToast();
  const [helpful, setHelpful] = useState(null); // null, true, false
  const [submitted, setSubmitted] = useState(false);
  const [reason, setReason] = useState("");
  const [details, setDetails] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleHelpfulSelect = async (val) => {
    setHelpful(val);
    if (val === true) {
      setSubmitting(true);
      try {
        await apiPost("/api/seo/feedback", {
          seoAuditId: auditId,
          url,
          helpful: true,
        });
        showSuccess("Thank you for your feedback!");
        setSubmitted(true);
        onSubmitted?.();
      } catch (err) {
        showError("Failed to submit feedback. Please try again.");
        setHelpful(null);
      } finally {
        setSubmitting(false);
      }
    }
  };

  const handleDetailedSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await apiPost("/api/seo/feedback", {
        seoAuditId: auditId,
        url,
        helpful: false,
        reason: reason || "Other",
        details,
      });
      showSuccess("Thank you for your detailed feedback!");
      setSubmitted(true);
      onSubmitted?.();
    } catch (err) {
      showError("Failed to submit feedback. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="card feedback-widget" style={{ padding: "1.5rem", textAlign: "center", border: "1px solid var(--border)", marginTop: "2rem" }}>
        <p style={{ margin: 0, fontWeight: "600", color: "var(--accent)" }}>✓ Feedback submitted. Thank you for helping us improve!</p>
      </div>
    );
  }

  return (
    <div className="card feedback-widget" style={{ padding: "1.5rem", border: "1px solid var(--border)", marginTop: "2rem" }}>
      {helpful === null && (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "12px" }}>
          <span style={{ fontWeight: "600", color: "var(--text-heading)" }}>Was this audit helpful?</span>
          <div style={{ display: "flex", gap: "10px" }}>
            <button
              onClick={() => handleHelpfulSelect(true)}
              className="btn btn-ghost"
              style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
              disabled={submitting}
            >
              👍 Useful
            </button>
            <button
              onClick={() => handleHelpfulSelect(false)}
              className="btn btn-ghost"
              style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
              disabled={submitting}
            >
              👎 Not useful
            </button>
          </div>
        </div>
      )}

      {helpful === false && (
        <form onSubmit={handleDetailedSubmit} style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <span style={{ fontWeight: "600", color: "var(--text-heading)" }}>How can we improve this report?</span>
          
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "0.95rem" }}>
              <input
                type="radio"
                name="reason"
                value="Score inaccurate"
                checked={reason === "Score inaccurate"}
                onChange={(e) => setReason(e.target.value)}
                required
              />
              Score seems inaccurate
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "0.95rem" }}>
              <input
                type="radio"
                name="reason"
                value="Missing issues"
                checked={reason === "Missing issues"}
                onChange={(e) => setReason(e.target.value)}
              />
              Missing important SEO issues
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "0.95rem" }}>
              <input
                type="radio"
                name="reason"
                value="Report confusing"
                checked={reason === "Report confusing"}
                onChange={(e) => setReason(e.target.value)}
              />
              Report recommendations are confusing
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "0.95rem" }}>
              <input
                type="radio"
                name="reason"
                value="Other"
                checked={reason === "Other"}
                onChange={(e) => setReason(e.target.value)}
              />
              Other
            </label>
          </div>

          <textarea
            placeholder="Please provide any specific details (optional)..."
            value={details}
            onChange={(e) => setDetails(e.target.value)}
            style={{
              width: "100%",
              minHeight: "80px",
              padding: "10px",
              borderRadius: "8px",
              border: "1px solid var(--border)",
              background: "var(--bg-input)",
              color: "var(--text)",
              fontFamily: "inherit",
              resize: "vertical",
            }}
          />

          <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
            <button
              type="button"
              onClick={() => setHelpful(null)}
              className="btn btn-ghost"
              disabled={submitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={submitting}
            >
              {submitting ? "Submitting..." : "Submit Feedback"}
            </button>
          </div>
        </form>
      )}
    </div>
  );
}
